import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonAlignJustify
  from 'components/atoms/Editors/EditorMenuButtonAlignJustify/EditorMenuButtonAlignJustify.styles';

const EditorMenuButtonAlignJustify = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonAlignJustify');

  return <StyledEditorMenuButtonAlignJustify buttonRef={ref} {...innerProps} />
});

EditorMenuButtonAlignJustify.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonAlignJustify;
